




































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { pageDataType, projectPageDataType } from "../types";
import { HOST, API_URL } from "../global";
import { FETCH_PROJECT_DATA } from "../store/actions.names";
import { SET_PROJECT_CURRENT_PAGE } from "../store/mutations.names";
import axios from "axios";
import { Action, Getter, Mutation } from "vuex-class";
import { TimelineMax, Power3 } from "gsap";
import { PROJECT_SETTINGS } from "../store/getters.names";
@Component({
  name: "ProjectPage",
})
export default class ProjectPage extends Vue {
  @Prop() public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  // @Getter("projectCategoryList") public projectCategoryList!: string | null;
  @Action(FETCH_PROJECT_DATA) public fetchData: any;
  @Mutation(SET_PROJECT_CURRENT_PAGE) public [SET_PROJECT_CURRENT_PAGE]: any;
  @Getter("isMenuLoaded") public menuLoaded!: boolean;
  @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
  public HOST: string = HOST;
  public currConcern: any | null = null;
  public urlResolved = false;
  public nav: boolean = false;
  smooth: any | null = null;
  public currentCategory: string | null = "All";
  public addedAnimation: boolean = false;
  public hover: number | null = null;
  public isHovering: number | null = null;
  public imagesLoaded: any | null = null;
  public header_image: any | null = null;
  public url: any | null = null;
  public slug: any | null = null;
  public activeLink: boolean = false;
  public componentKey: number = 0;
  @Getter("projectList") public projects!: projectPageDataType[];
  @Getter(PROJECT_SETTINGS) projectSettings!: any;
 public isProjects: boolean = false;
  @Watch("$route", { immediate: true })
  handleHash() {
    switch ((this as any).$route.hash) {
      case "#completed":
        this.currentCategory = "completed";
        break;
      case "#upcoming":
        this.currentCategory = "upcoming";
        break;
      case "#ongoing":
        this.currentCategory = "ongoing";
        break;
      default:
        this.currentCategory = null;
    }

      if(this.filteredPages.length > 0){
         this.isProjects = true;
       }
       else{
         this.isProjects = false;
       }
  }

  get filteredPages() {
    if (!this.projects) {
      return [];
    }
    if (this.currentCategory == null) {
      return this.projects;
    }
    return this.projects.filter((item: any) => {
      return item.status == this.currentCategory;
    });
  }

  public abimgnim(): void {
    var abimgnim = new TimelineMax({});
    abimgnim
      .staggerFrom(
        ".abimg-ban",
        0.7,
        {
          scale: 0.95,
          autoAlpha: 0,
          opacity: 0,
          ease: Power3.easeOut,
          clearProps: "all",
        },
        0.05
      )
      .staggerFrom(
        ".ab-text h1",
        0.7,
        {
          yPercent: 20,
          autoAlpha: 0,
          opacity: 0,
          ease: Power3.easeOut,
          clearProps: "all",
        },
        0.05
      );
  }

  public mounted() {
    this.fetchData(this.pageData.id);
  }
}
